/**
 * 设置模块路由
 * 对应菜单：设置 > 权限设置/基础设置
 */

export default [
  // 设置 - 重定向到权限设置
  {
    path: 'admin/setting',
    name: 'AdminSetting',
    redirect: '/admin/setting/menus',
    meta: {
      requiresAuth: true,
      auth: 'admin-setting',
      title: '设置'
    }
  },
  // 权限设置 - 重定向到菜单管理
  {
    path: 'admin/setting/auth',
    name: 'AdminSettingAuth',
    redirect: '/admin/setting/menus',
    meta: {
      requiresAuth: true,
      auth: 'admin-setting-auth',
      title: '权限设置'
    }
  },
  // 菜单管理
  {
    path: 'admin/setting/menus',
    name: 'AdminSettingMenus',
    component: () =>
      import(/* webpackChunkName: "setting-menus" */ '@/views/setting/menus/MenuListView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'admin-setting-menus',
      title: '菜单管理'
    }
  },
  // 菜单编辑
  {
    path: 'admin/setting/menus/edit',
    name: 'AdminSettingMenusEdit',
    component: () =>
      import(/* webpackChunkName: "setting-menus-edit" */ '@/views/setting/menus/MenuEditView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'setting-menus-edit',
      title: '菜单编辑',
      hidden: true // 不在菜单中显示
    }
  },
  // 角色组管理
  {
    path: 'admin/setting/role',
    name: 'AdminSettingRole',
    component: () =>
      import(/* webpackChunkName: "setting-role" */ '@/views/setting/role/RoleListView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'admin-setting-role',
      title: '角色组管理'
    }
  },
  // 角色组编辑
  {
    path: 'admin/setting/role/edit',
    name: 'AdminSettingRoleEdit',
    component: () =>
      import(/* webpackChunkName: "setting-role-edit" */ '@/views/setting/role/RoleEditView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'setting-role-edit',
      title: '角色组编辑',
      hidden: true
    }
  },
  // 管理员管理
  {
    path: 'admin/setting/admin',
    name: 'AdminSettingAdmin',
    component: () =>
      import(/* webpackChunkName: "setting-admin" */ '@/views/setting/admin/AdminListView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'admin-setting-admin',
      title: '管理员管理'
    }
  },
  // 管理员编辑
  {
    path: 'admin/setting/admin/edit',
    name: 'AdminSettingAdminEdit',
    component: () =>
      import(/* webpackChunkName: "setting-admin-edit" */ '@/views/setting/admin/AdminEditView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'setting-admin-edit',
      title: '管理员编辑',
      hidden: true
    }
  },
  // 基础设置
  {
    path: 'admin/setting/basic',
    name: 'AdminSettingBasic',
    component: () =>
      import(/* webpackChunkName: "setting-basic" */ '@/views/setting/basic/BasicSettingView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'admin-setting-basic',
      title: '基础设置'
    }
  },
  // 素材库
  {
    path: 'admin/setting/attachment',
    name: 'AdminSettingAttachment',
    component: () =>
      import(/* webpackChunkName: "setting-attachment" */ '@/views/setting/attachment/AttachmentView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'admin-setting-attachment',
      title: '素材库'
    }
  }
]
